import axios from 'axios'
import React, { useEffect, useState } from 'react'
import ReactDOM from "react-dom"
import Spinner from '../ui/Spinner'
import { GrMapLocation } from "react-icons/gr";
import { FaGithubAlt } from "react-icons/fa";
import { RiUserFollowFill, RiUserFollowLine } from "react-icons/ri";
import { BiGitRepoForked } from "react-icons/bi";
import { VscGistSecret } from "react-icons/vsc";
import Repos from '../repos/Repos';


function SearchedUser(props) {

    const [searchedUserName, setSearchedUserName] = useState({})
    const [searchedUserRepos, setSearchedUserRepos] = useState([])
    const { loading, setLoading, githubClientId, githubClientSecret } = props

    useEffect(() => {
        setLoading(true)
        axios.get(`https://api.github.com/users/${props.match.params.login}?client_id=${githubClientId}&client_secret=${githubClientSecret}`)
            .then(res => {
                setLoading(false)
                setSearchedUserName(res.data)
            })
        axios.get(`https://api.github.com/users/${props.match.params.login}/repos?per_page=5&sort=created:asc&client_id=${githubClientId}&client_secret=${githubClientSecret}`)
            .then(res => {
                setSearchedUserRepos(res.data)
            })

    }, [setLoading, props.match.params.login, githubClientSecret, githubClientId])

    // console.log(searchedUserRepos)
    const {
        avatar_url,
        bio,
        blog,
        followers,
        following,
        hireable,
        html_url,
        location,
        login,
        name,
        public_repos,
        public_gists,
        company
    } = searchedUserName;

    let Blog;
    if (/^http:\/\//.test(blog)) {
        Blog = blog;
    } else if (/^https:\/\//.test(blog)) {
        Blog = blog;
    } else if (/^www\./.test(blog)) {
        console.log("hello")
        Blog = `https://${blog}`;
    } else {
        Blog = `https://www.${blog}`
    }

    return ReactDOM.createPortal(
        <div className="container-md">
            <div className="about">
                {
                    loading && <Spinner />
                }
                <div className="flex">
                    <div>
                        <img src={avatar_url} className="profile avatar" alt="profile" />

                    </div>
                    <div className="main" >
                        <h1 className="main-name" >
                            {
                                name || login
                            }
                        </h1>
                        <p className="main-bio" >
                            {
                                bio || "GitHub user"
                            }
                        </p>
                        <div className="main-location" >
                            {
                                <p>{location || "Somewhere on Earth"}</p>
                            }
                            <GrMapLocation className="icon-loc" />
                        </div>
                        <a href={html_url} className="flex-btn greet"> <FaGithubAlt className="fa" />GitHub</a>

                    </div>

                </div>
                <div className="flex flex-md">
                    {
                        blog ? <a href={Blog} className="flex-btn btn-1 greet"> Blog</a> : (hireable) ? <h1 className="des">Hireable</h1> : <h5 className="des">{company}</h5>
                    }
                </div>
                <div className="stats">
                    <h1 className="repos-title">GitHub Stats:</h1>
                    <div className="grid">
                        <div className="info">
                            <div className="info-child">
                                <RiUserFollowLine />
                                <h3 className="info-title">Followers</h3>
                            </div>
                            <p className="info-des">{followers}</p>
                        </div>
                        <div className="info">
                            <div className="info-child">
                                <RiUserFollowFill />
                                <h3 className="info-title">Following</h3>
                            </div>
                            <p className="info-des">{following} </p>
                        </div>
                        <div className="info">
                            <div className="info-child">
                                <BiGitRepoForked />
                                <h3 className="info-title">Repository</h3>
                            </div>
                            <p className="info-des">{public_repos} </p>
                        </div>
                        <div className="info">
                            <div className="info-child">
                                <VscGistSecret />
                                <h3 className="info-title">Gists</h3>
                            </div>
                            <p className="info-des">{public_gists} </p>
                        </div>
                    </div>

                </div>
            </div>
            <Repos repos={searchedUserRepos} />

        </div>, document.getElementById("portal")
    )
}

export default SearchedUser